import { Component } from '@angular/core';

import { IonicPage, NavController, NavParams ,LoadingController} from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';
import { CoPersonaldetailsPage } from '../co-personaldetails/co-personaldetails';
import { LeadThankYouPage } from '../lead-thank-you/lead-thank-you';
import { PropertyDocumentListPage } from '../property-document-list/property-document-list';

import {GenericFormValidationProvider} from "../../providers/common/form-validation"
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
/**
 * Generated class for the FinancialdetailsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-financialdetails',
  templateUrl: 'financialdetails.html',
})
export class FinancialdetailsPage {
  model:any={}
  modelRequest:any={}
  fetchData:any = {}
  fetchPincodeData:any = {}
  modelLead:any={};
  errorSingleDisplay:any={};
  cityFlag:any=false;
  cityAfterFillterBlank:any=[];
  cities:any=[];
  previousData:any={};
  errorDisplay:any={};
  classP:any='autocom';
  occupationid:any=28;
 constructor(private fb: FormBuilder,private fv : GenericFormValidationProvider,private cp: CommonProvider, public loadingCtrl: LoadingController,public navCtrl: NavController, public navParams: NavParams) {
    this.model.lead={};
    this.modelRequest={};
    this.model.applicants=[];
    this.fetchPincodeData.ibhfl_city={}
  }

  ionViewDidLoad() {
    
    this.employerMaster("AIR");
    this.fetchData = JSON.parse(this.navParams.data).Payload.lead
    this.fetchData.applicants = JSON.parse(this.navParams.data).Payload.lead.applicants.filter((res:any)=>{
      return res.ibhfl_applicantrole=="303710000"
    });
    this.modelRequest.ibhfl_professionmasterid = 'BSN';
    //console.log('ionViewDidLoad FinancialdetailsPage',this.fetchData);
    this.model.lead.leadid = JSON.parse(this.navParams.data).Payload.lead.leadid;
    this.model.lead.ibhfl_stageid = "3"
    this.modelRequest.applicantid = this.fetchData.applicants[0].applicantid;
    this.occupationid=this.fetchData.ibhfl_Occupationid?this.fetchData.ibhfl_Occupationid:this.fetchData.applicants[0].ibhfl_Occupationid;
    this.modelRequest.ibhfl_employer_name=this.fetchData.applicants[0].ibhfl_employer_name;
    this.modelRequest.ibhfl_EmployerNameid=this.fetchData.applicants[0].ibhfl_EmployerNameid
    this.modelRequest.ibhfl_pan=this.fetchData.applicants[0].ibhfl_pan;
    this.modelRequest.ibhfl_panverified=this.fetchData.applicants[0].ibhfl_panverified

    this.modelRequest.ibhfl_averageprofititr=this.numberFormatter(this.fetchData.applicants[0].ibhfl_averageprofititr)
    this.modelRequest.ibhfl_averagegrossreceipts=this.numberFormatter(this.fetchData.applicants[0].ibhfl_averagegrossreceipts)
    
    this.modelRequest.ibhfl_totalmonthlyfixedemi=this.numberFormatter(this.fetchData.applicants[0].ibhfl_totalmonthlyfixedemi)
    this.modelRequest.ibhfl_monthlyfixedincome=this.numberFormatter(this.fetchData.applicants[0].ibhfl_monthlyfixedincome)
    this.modelRequest.ibhfl_monthlyvariableincome=this.numberFormatter(this.fetchData.applicants[0].ibhfl_monthlyvariableincome)
    this.modelRequest.ibhfl_othernonbusinessincome=this.numberFormatter(this.fetchData.applicants[0].ibhfl_othernonbusinessincome)
    this.modelRequest.ibhfl_addcoapplicantincome=this.fetchData.applicants[0].ibhfl_addcoapplicantincome.toString()
    this.modelRequest.ibhfl_otherincome=this.fetchData.applicants[0].ibhfl_otherincome.toString()
    this.modelRequest.ibhfl_rental=this.numberFormatter(this.fetchData.applicants[0].ibhfl_rental)
    this.modelRequest.ibhfl_agri=this.numberFormatter(this.fetchData.applicants[0].ibhfl_agri)
    this.modelRequest.ibhfl_divinterest=this.numberFormatter(this.fetchData.applicants[0].ibhfl_divinterest)
    this.modelRequest.ibhfl_otherincomevalue=this.numberFormatter(this.fetchData.applicants[0].ibhfl_otherincomevalue)

   
  }


  addFocus(e){
   this.cityFlag=false
  }
  search(e){
    ////console.log(e)
    if(e.keyCode=="8"){
      this.cities = this.cityAfterFillterBlank;
    }
     let val = e.target.value;
    

    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.cityFlag=true
      this.cities = this.cities.filter((item) => {
        return (item.ibhfl_name.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })

    }else{
      this.cityFlag=false
      this.cities = this.cityAfterFillterBlank;
    }
  }
  employerMaster(ev){
   
    let request:any={}
    request.employerName=ev=='AIR'?'AIR':ev.target.value
    try{
      if(request.employerName.length%2==0 && ev!='AIR'){
         let loading = this.loadingCtrl.create({
           content: 'Please wait...'
          });
          loading.present();
        this.cp.getEmployers(loading,request).then((res:any)=>{
          loading.dismiss(); 
          ////console.log("empmaster",JSON.parse(res))
          try{
               if(JSON.parse(res).Error && JSON.parse(res).Error.ErrorCode){
                this.cities = []
                this.cityAfterFillterBlank = []
              }else{
                this.classP=JSON.parse(res).Payload.employersDetails.length>0?"autocom":"autocomp"
                this.cities = JSON.parse(res).Payload.employersDetails
                this.cityAfterFillterBlank = JSON.parse(res).Payload.employersDetails
              }
          }catch(e){
              this.cities = []
              this.cityAfterFillterBlank = []
          }
         
          

        })
      }else{
        if(ev=='AIR'){
          let loading = this.loadingCtrl.create({
           content: 'Please wait...'
          });
          loading.present();
        this.cp.getEmployers(loading,request).then((res:any)=>{
          loading.dismiss(); 
          ////console.log("empmaster",JSON.parse(res))
          try{
               if(JSON.parse(res).Error && JSON.parse(res).Error.ErrorCode){
                this.cities = []
                this.cityAfterFillterBlank = []
              }else{
                this.classP=JSON.parse(res).Payload.employersDetails.length>0?"autocom":"autocomp"
                this.cities = JSON.parse(res).Payload.employersDetails
                this.cityAfterFillterBlank = JSON.parse(res).Payload.employersDetails
              }
          }catch(e){
              this.cities = []
              this.cityAfterFillterBlank = []
          }
          

        })
        }
         
      }
      
    }catch(e){
      ////console.log("catch the error",e);
    }   
    
  }


  /*

  PAN CARD VERIFICATION

  */


  panVerification(ev){
    this.modelRequest.panNumber=ev.target.value.toUpperCase();
    if(ev.target.value.length==10){
        let loading = this.loadingCtrl.create({
               content: 'Please wait...'
              });
              loading.present();
         
        try{
          let request:any={}
          request.panNumber=ev.target.value
          request.applicantid=this.fetchData.applicants[0].applicantid
          this.cp.panVerification(loading,request).then((res:any)=>{
              loading.dismiss(); 
              // ////console.log("panVerification",JSON.parse(res))
              try{
                if(JSON.parse(res).Error && JSON.parse(res).Error.ErrorCode){
                    this.errorDisplay.panNumber = JSON.parse(res).Error.ErrorMessage
                    this.errorDisplay.valid = true;
                    this.modelRequest.ibhfl_panverified=false;
                
                }else{
                  this.errorDisplay.panNumber = "";

                  if(JSON.parse(res).Payload.remark=="Existing And Valid"){
                    this.modelRequest.panNumber=JSON.parse(res).Payload.panNumber;
                    this.modelRequest.ibhfl_panverified=true
                    this.modelRequest.ibhfl_pandetailsname=JSON.parse(res).Payload.firstName+" "+JSON.parse(res).Payload.middleName+" "+JSON.parse(res).Payload.lastName;
                    this.errorDisplay.valid = false;
                  }
                   

                }
              }catch(e){
                    this.modelRequest.panNumber="";
                    this.modelRequest.ibhfl_panverified=false;
                    this.errorDisplay.valid = true;
              }
              
              

            })
        }catch(e){
          this.errorDisplay.valid = true;
          ////console.log("catch the error",e);
        }
    }
    
  }
  panChangeVerification(ev){
     
        let loading = this.loadingCtrl.create({
               content: 'Please wait...'
              });
              loading.present();
         
        try{
          let request:any={}
          request.panNumber=ev.target.value
          request.applicantid=this.fetchData.applicants[0].applicantid
          ////console.log("request for pan",request)
          this.cp.panVerification(loading,request).then((res:any)=>{
              loading.dismiss(); 
              ////console.log("panVerification",JSON.parse(res))
              try{
                if(JSON.parse(res).Error && JSON.parse(res).Error.ErrorCode){
                    this.errorDisplay.panNumber = JSON.parse(res).Error.ErrorMessage
                    this.errorDisplay.valid = true;
                    this.modelRequest.ibhfl_panverified=false;
                
                }else{
                  this.errorDisplay.panNumber = "";
                  if(JSON.parse(res).Payload.remark=="Existing And Valid"){
                    this.modelRequest.panNumber=JSON.parse(res).Payload.panNumber;
                    this.modelRequest.ibhfl_panverified=true
                    this.modelRequest.ibhfl_pandetailsname=JSON.parse(res).Payload.firstName+" "+JSON.parse(res).Payload.middleName+" "+JSON.parse(res).Payload.lastName;
                    this.errorDisplay.valid = false;
                  }
                   

                }
              }catch(e){
                    this.modelRequest.panNumber="";
                    this.modelRequest.ibhfl_panverified=false;
                    this.errorDisplay.valid = true;
              }
              

            })
        }catch(e){
          this.errorDisplay.valid = true;
          ////console.log("catch the error",e);
        }
    
    
  }
  removeFocus(e){
    ////console.log(e)
  }
  addCity(city){
     this.cityFlag=false
     this.modelRequest.ibhfl_EmployerNameid= city.ibhfl_code
     this.modelRequest.ibhfl_employer_name= city.ibhfl_name
     this.modelRequest.ibhfl_otheremployername=""
   }


changeOtherIncome(val){
  ////console.log(val)
  if(val){

  }else{
      this.modelRequest.ibhfl_rental = null
      this.modelRequest.ibhfl_agri = null
      this.modelRequest.ibhfl_divinterest = null
      this.modelRequest.ibhfl_otherincomevalue = null
  }
  
}
 
checkValidation(keyname?:any){
   if(Object.keys(this.errorDisplay).length>0){
    this.errorSingleDisplay = this.fv.checkValidationFormAllControls(document.forms['financialdetails'],true,[]);
    if(Object.keys(this.errorSingleDisplay).length>0){
     var index = Object.keys(this.errorSingleDisplay).findIndex((res:any)=>{
        return res==keyname
      })
        //console.log(index);

      if(index==-1){
        delete this.errorDisplay[keyname];
        if(this.errorDisplay.length>0 && this.errorDisplay.length<=1)
        {
          this.errorDisplay.valid=false
        }
        //console.log(this.errorDisplay);
      }
    }
    
   }else{
    if(!this.modelRequest.ibhfl_pan)
      this.modelRequest.ibhfl_panverified=false;
   }
   
  }  
updateInfo(){
  
  this.errorDisplay = this.fv.checkValidationFormAllControls(document.forms["financialdetails"],true,[]);
  if(!this.modelRequest.ibhfl_employer_name && this.occupationid=='28'){
    this.errorDisplay.employer_name="Employer name is required.";
    this.errorDisplay.valid = true;
  }
  //console.log(this.errorDisplay);
  //console.log(this.fetchData.applicants[0].ibhfl_residentialstatusid)
  if(!this.modelRequest.ibhfl_panverified && this.fetchData.applicants[0].ibhfl_residentialstatusid=="RI"){
    this.errorDisplay.panNumber="Pan is not verified.";
    this.errorDisplay.valid = true;
  }
  if(!this.modelRequest.ibhfl_EmployerNameid){
    this.modelRequest.ibhfl_otheremployername=this.modelRequest.ibhfl_employer_name
  }
  if(this.errorDisplay.valid){
     return false;
  }else{
    this.model.applicants=[];
    // this.modelRequest.ibhfl_averagegrossreceipts=0;
    this.modelRequest.ibhfl_averageprofititr = this.modelRequest.ibhfl_averageprofititr?parseInt(this.modelRequest.ibhfl_averageprofititr.toString().replaceAll(',',"")):0
    this.modelRequest.ibhfl_totalmonthlyfixedemi = this.modelRequest.ibhfl_totalmonthlyfixedemi? parseInt(this.modelRequest.ibhfl_totalmonthlyfixedemi.toString().replaceAll(',',"")):0
    this.modelRequest.ibhfl_monthlyfixedincome = this.modelRequest.ibhfl_monthlyfixedincome?parseInt(this.modelRequest.ibhfl_monthlyfixedincome.toString().replaceAll(',',"")):0
    this.modelRequest.ibhfl_monthlyvariableincome = this.modelRequest.ibhfl_monthlyvariableincome?parseInt(this.modelRequest.ibhfl_monthlyvariableincome.toString().replaceAll(',',"")):0
    this.modelRequest.ibhfl_othernonbusinessincome = this.modelRequest.ibhfl_othernonbusinessincome?parseInt(this.modelRequest.ibhfl_othernonbusinessincome.toString().replaceAll(',',"")):0;
    this.modelRequest.ibhfl_averagegrossreceipts =this.modelRequest.ibhfl_averagegrossreceipts? parseInt(this.modelRequest.ibhfl_averagegrossreceipts.toString().replaceAll(',',"")):0
    
    // this.modelRequest.ibhfl_addcoapplicantincome = this.modelRequest.ibhfl_addcoapplicantincome;
    if(this.modelRequest.ibhfl_addcoapplicantincome==="true"){
      this.modelRequest.ibhfl_addcoapplicantincome =true
    }
    if(this.modelRequest.ibhfl_addcoapplicantincome==="false"){
      this.modelRequest.ibhfl_addcoapplicantincome = false
    }
    if(this.modelRequest.ibhfl_otherincome==="true"){
      this.modelRequest.ibhfl_otherincome ="true";
    }
    if(this.modelRequest.ibhfl_otherincome==="false"){
      this.modelRequest.ibhfl_otherincome = "false";
    }
    

    this.modelRequest.ibhfl_rental =this.modelRequest.ibhfl_rental? parseInt(this.modelRequest.ibhfl_rental.toString().replaceAll(',',"")):0
    this.modelRequest.ibhfl_agri = this.modelRequest.ibhfl_agri?parseInt(this.modelRequest.ibhfl_agri.toString().replaceAll(',',"")):0
    this.modelRequest.ibhfl_divinterest = this.modelRequest.ibhfl_divinterest?parseInt(this.modelRequest.ibhfl_divinterest.toString().replaceAll(',',"")):0
    this.modelRequest.ibhfl_otherincomevalue = this.modelRequest.ibhfl_otherincomevalue?parseInt(this.modelRequest.ibhfl_otherincomevalue.toString().replaceAll(',',"")):0
    this.model.applicants.push(this.modelRequest);
    //console.log("update click on submit button",this.model)
      let loading = this.loadingCtrl.create({
             content: 'Please wait...'
            });
       
            loading.present();
      this.cp.updateLead(loading,this.model).then((res:any)=>{
        loading.dismiss();
         
         try{
          //console.log("vvvvvvvvv",JSON.parse(res))
            if(JSON.parse(res).Payload){
               let applicantsOld:any = [];
               let paramDataFetch:any= JSON.parse(this.navParams.data);
               applicantsOld=JSON.parse(this.navParams.data).Payload.lead.applicants
               if(this.modelRequest.ibhfl_addcoapplicantincome){
                applicantsOld[0].ibhfl_addcoapplicantincome=true;
                // JSON.parse(this.navParams.data).Payload.lead.applicants[0].ibhfl_addcoapplicantincome=true;
                // console.log("true applicant with co",applicantsOld);
               }else{
                applicantsOld[0].ibhfl_addcoapplicantincome=false;
                // console.log("fasle applicant with co",applicantsOld);
                // JSON.parse(this.navParams.data).Payload.lead.applicants[0].ibhfl_addcoapplicantincome=false;

               }
                paramDataFetch.Payload.lead.applicants=applicantsOld;
                this.navParams.data=JSON.stringify(paramDataFetch);
                // console.log(JSON.parse(this.navParams.data),applicantsOld,"ibhfl_addcoapplicantincome")
               if(localStorage.getItem('loantype')=='HL'){
                this.navCtrl.push(PropertyDocumentListPage,this.navParams)
               }else if(localStorage.getItem('loantype')=='LAP' && this.modelRequest.ibhfl_addcoapplicantincome){
                this.navCtrl.push(CoPersonaldetailsPage,this.navParams)

               // this.navCtrl.push(LeadThankYouPage,this.navParams) 
               }else{
                this.navCtrl.setRoot(LeadThankYouPage,this.navParams)
               }
           }else{

           }
         }catch(e){
          ////console.log("error getting",e);
         }
         

         
         
      })
    }
 
}
changeAmountFormat(keyname,value){
  
    if(!value)
    {
      value="0"
    }
    
    value=value.toString();
    if(parseInt(value.replace(/,/g,""))>0){
      //console.log(value,keyname);
      if(keyname == 'ibhfl_monthlyfixedincome'){
        this.modelRequest.ibhfl_monthlyfixedincome=this.numberFormatter(value.replaceAll(",",""));
      }else if(keyname == 'ibhfl_totalmonthlyfixedemi'){
        this.modelRequest.ibhfl_totalmonthlyfixedemi=this.numberFormatter(value.replaceAll(",",""));
      }else if(keyname == 'ibhfl_otherincomevalue'){
        this.modelRequest.ibhfl_otherincomevalue=this.numberFormatter(value.replaceAll(",",""));
      }else if(keyname == 'ibhfl_divinterest'){
        this.modelRequest.ibhfl_divinterest=this.numberFormatter(value.replaceAll(",",""));
      }else if(keyname == 'ibhfl_rental'){
        this.modelRequest.ibhfl_rental=this.numberFormatter(value.replaceAll(",",""));
      }
      else if(keyname == 'ibhfl_averageprofititr'){
        this.modelRequest.ibhfl_averageprofititr=this.numberFormatter(value.replaceAll(",",""));
      }else if(keyname == 'ibhfl_othernonbusinessincome'){
        this.modelRequest.ibhfl_othernonbusinessincome=this.numberFormatter(value.replaceAll(",",""));
      }else if(keyname == 'ibhfl_averagegrossreceipts'){
        this.modelRequest.ibhfl_averagegrossreceipts=this.numberFormatter(value.replaceAll(",",""));
      }else if(keyname == 'ibhfl_agri'){
        this.modelRequest.ibhfl_agri=this.numberFormatter(value.replaceAll(",",""));
      }else if(keyname == 'ibhfl_monthlyvariableincome'){
        this.modelRequest.ibhfl_monthlyvariableincome=this.numberFormatter(value.replaceAll(",",""));
      }else{
        // this.modelRequest.ibhfl_monthlyvariableincome=this.numberFormatter(value.replaceAll(",",""));
      }
    }
  }
  numberFormatter(x) {
    //console.log(x)
    if(!x){
      return
    }else{
          x = x.toString();
          var afterPoint = '';
          if (x.indexOf('.') > 0)
              afterPoint = x.substring(x.indexOf('.'), x.length);
          x = Math.floor(x);
          x = x.toString();
          var lastThree = x.substring(x.length - 3);
          var otherNumbers = x.substring(0, x.length - 3);
          if (otherNumbers != '')
              lastThree = ',' + lastThree;
          var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint;
          return res;
    }

  }


}



// WEBPACK FOOTER //
// ./src/pages/financialdetails/financialdetails.ts